import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import '../pages/Events.css';

const FALLBACK_IMG = '/assets/hero/hero-bg.webp';

function fmtDateRange(start, end) {
  if (!start) return '';
  const s = new Date(start);
  const e = end ? new Date(end) : s;
  if (s.toDateString() === e.toDateString()) {
    return s.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  }
  if (s.getFullYear() === e.getFullYear() && s.getMonth() === e.getMonth()) {
    return `${s.getDate()}–${e.getDate()} ${s.toLocaleDateString('en-IN', { month: 'short', year: 'numeric' })}`;
  }
  return `${s.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' })} – ${e.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}`;
}

const UpcomingEvents = () => {
  const [events, setEvents] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    api.getEvents()
      .then((data) => { if (active) setEvents(Array.isArray(data) ? data.slice(0, 3) : []); })
      .catch(() => { /* hide section on error */ })
      .finally(() => { if (active) setLoaded(true); });
    return () => { active = false; };
  }, []);

  // Hide section entirely if there's nothing to show.
  if (loaded && events.length === 0) return null;

  return (
    <section className="upcoming-events">
      <div className="container">
        <div className="upcoming-events__head">
          <p className="section-label">Workshops &amp; Masterclasses</p>
          <h2 className="section-title">Upcoming events</h2>
          <div className="section-divider">
            <span className="line" />
            <span className="dot" />
            <span className="line" />
          </div>
        </div>

        <div className="upcoming-events__grid">
          {events.map((e) => {
            const price = Number(e.cost_inr) || 0;
            return (
              <Link key={e.id} to={`/events/${e.slug}`} className="event-card">
                <div className="event-card__image">
                  <img src={e.image || FALLBACK_IMG} alt={e.title} loading="lazy" />
                  <div className="event-card__date">{fmtDateRange(e.start_date, e.end_date)}</div>
                </div>
                <div className="event-card__body">
                  <div className="event-card__meta">
                    {e.venue && <span>📍 {e.venue}</span>}
                  </div>
                  <h3 className="event-card__title">{e.title}</h3>
                  {e.subtitle && <p className="event-card__subtitle">{e.subtitle}</p>}
                  <div className="event-card__foot">
                    <span className={`event-card__price ${price === 0 ? 'event-card__price--free' : ''}`}>
                      {price > 0 ? `₹${price.toLocaleString('en-IN')}` : 'Free'}
                    </span>
                    <span className="event-card__cta">
                      View
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                      </svg>
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="upcoming-events__cta">
          <Link to="/events" className="btn-outline">View all events</Link>
        </div>
      </div>
    </section>
  );
};

export default UpcomingEvents;
